import React from 'react';
import { sanitizePhoneNumber } from 'lib/phoneNumbers';
import { useTranslation } from 'react-i18next';
import { Link } from '@simplybusiness/mobius';

const PhoneNumber = ({ number, onClick }: {number: string, onClick?: () => void}) => {
  const { t } = useTranslation();
  const phoneNumberAsLink = `tel:${sanitizePhoneNumber(number, t('international_phone_prefix'))}`;

  return <Link href={phoneNumberAsLink} onClick={onClick}>{number}</Link>;
};

export default PhoneNumber;
